import React from "react";
import { AppReleaseVersionsTemplate } from "themes/administration/app-release/components";

function AppReleaseVersions(props) {
    return <AppReleaseVersionsTemplate {...props} />;
}

export default AppReleaseVersions;
